module.exports = [
  {
    key: 'header_home',
    name: 'home',
    icon: 'home',
    linkParent: '/app/home',
  },
  {
    key: 'header_applications',
    name: 'Applications',
    icon: 'home',
    linkParent: '/app/applications',
  },
  {
    key: 'header_services',
    name: 'Services',
    icon: 'home',
    linkParent: '/app/services',
  },
  {
    key: 'header_properties',
    name: 'Properties',
    icon: 'properties',
    linkParent: '/app/properties?type=ownership',
  },
  {
    key: 'header_directory',
    name: 'Directory',
    icon: 'directory',
    linkParent: '/app/directory',
  },
  {
    key: 'header_contracts',
    name: 'contracts',
    icon: 'contracts',
    linkParent: '/app/contracts?type=Lease',
  },
];
